// extracted by mini-css-extract-plugin
export default {"main":"center-info_main__8lao2"};